export const environment = {
  production: false,
  apiUrl: '/advcare/api',
  auth: {
    sso: {
      enabled: false,
      providerName: 'SSO Corporativo',
    },
  },
};
